import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType, DepotPutPayload } from '@types'

import { DepotsApi } from './api'

const useUpdateDepot = (onSuccess?: () => void) => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_update_depot.'

  const queryClient = useQueryClient()

  const onUpdateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.SUPPLIERS_ADMIN)
    if (onSuccess) {
      onSuccess()
    }
  }

  const { mutate, isLoading: isLoadingDepot } = useMutation(
    ({ depotId, depotData }: { depotId: number; depotData: DepotPutPayload }) =>
      DepotsApi.updateDepot(depotId, depotData),
    {
      onSuccess: () => {
        notification.success({
          message: t('depot_modal.Depot_updated_successfully'),
        })
        onUpdateSuccess()
      },
      onError: (err: unknown) => {
        const error = err as AxiosErrorType

        const errorResponse = error.data.error as {
          type: string
          status: number
          message: string
        }
        if (errorResponse.type === 'NO_ACTIVE_ROUTE') {
          const hint =
            errorResponse.message.length > 62
              ? `${t(`${tPreffix}no_active_route_hint`)} ${errorResponse.message.substring(
                  62,
                  errorResponse.message.length,
                )}`
              : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

          notification.error({
            message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
          })
        } else {
          notification.error({
            message: t('depot_modal.Error_could_not_update_depot'),
          })
        }
      },
    },
  )

  return {
    updateDepot: mutate,
    isLoadingDepot,
  }
}

export { useUpdateDepot }
